import classNames from 'classnames'
import { UserRoundX } from 'lucide-react'
import { useMemo } from 'react'

import Pill from '@/elements/Pill'
import { colors, type ColorVariant } from '@/utils/theme'

import './Avatar.scss'

interface AvatarProps {
  src?: string
  name?: string
  notifications?: number
  size?: 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge'
  color?: ColorVariant
  isMember?: boolean
}

function Avatar({
  src,
  name,
  notifications,
  size = 'medium',
  color,
  isMember
}: AvatarProps) {
  const initials = useMemo(() => {
    if (name) {
      const namesArray = name.trim().split(' ')
      if (namesArray.length === 1) {
        return namesArray[0].charAt(0).toUpperCase()
      } else {
        return (namesArray[0].charAt(0) + namesArray[namesArray.length - 1].charAt(0)).toUpperCase()
      }
    }
    return '--'
  }, [name])

  const isValidUrl = useMemo(() => {
    if (src) {
      return src.startsWith('http://') || src.startsWith('https://')
    }
    return false
  }, [src])

  const isUndefined = !name

  return (
    <div
      className={classNames('avatar', { [size]: true, member: isMember })}
      style={{ outlineColor: color ? colors[color] : undefined }}
    >
      {src && isValidUrl ? <img src={src} alt={name} /> : (
        <span>{isUndefined ? <UserRoundX /> : initials}</span>
      )}
      {typeof notifications === 'number' && (
        <Pill variant='notification' notifications={notifications}>
          {notifications}
        </Pill>
      )}
    </ div>
  )
}

export default Avatar

